<template>
	<div class="userManage mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">用户管理</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">用户列表</span>
				</div>
				<!-- <el-button type="success" @click="exportData">导出</el-button> -->
			</div>
			<div class="BtnBox disBetween">
				<div class="searchBox disBetween">
					<div class="disBetween searchLeft">
						<div class="myinputBox">
							<el-input clearable v-model="searchObj1.loginId" placeholder="请输入用户名">
							</el-input>
						</div>
						<div class="myinputBox">
							<el-input clearable v-model="searchObj1.communityName" placeholder="请输入社区名称">
							</el-input>
						</div>
						<div class="myinputBox">
							<el-input clearable v-model="searchObj1.phone" type="Number" placeholder="请输入联系方式">
							</el-input>
						</div>
						<div class="myinputBox" v-if="statusList">
							<el-select clearable v-model="searchObj1.loginStatus" slot="prepend" placeholder="请选择用户状态">
								<el-option v-for="(item,inx) in statusList" :key="inx" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<div class="myinputBox" v-if="effectiveList">
							<el-select clearable v-model="searchObj1.effectiveFlag" slot="prepend"
								placeholder="请选择是否为有效用户">
								<el-option v-for="(item,inx) in effectiveList" :key="inx" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<el-button type="success" @click="toSearch">查询</el-button>
					</div>
					<el-button type="success" @click="exportData">导出</el-button>
				</div>

			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" stripe style="width: 100%">
							<el-table-column type="index" label="序号">
							</el-table-column>
							<!-- <el-table-column show-overflow-tooltip prop="loginName" label="用户名">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="userName" label="姓名" width="90">
							</el-table-column> -->
							<el-table-column show-overflow-tooltip prop="userName" label="用户名">
								<template slot-scope="scope">
									<span>{{scope.row.loginId?((scope.row.loginId).slice(10)):""}}</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="userName" label="用户状态" width="90">
								<template slot-scope="scope">
									<span>{{getName(scope.row.loginStatus,statusList)}}</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="communityName" label="常驻小区">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="phone" label="联系方式" width="100">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="minPower" label="最小功率(W)">
								<template slot-scope="scope">
									<span>{{scope.row.minPower/10}}</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="maxPower" label="最大功率(W)">
								<template slot-scope="scope">
									<span>{{scope.row.maxPower/10}}</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="accountBalance" label="剩余充值金(元)">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="accountExtraBalance" label="剩余赠送金(元)">
								<template slot-scope="scope">
									<div class="disStart">
										<span>{{scope.row.accountExtraBalance}}</span>
										<span title="添加赠送金" class="money_add" @click="addMoney(scope.row)"
											v-if="scope.row.loginStatus!=2"></span>
									</div>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="accountBalanceUsed" label="已用充值金(元)">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="accountExtraBalanceUsed" label="已用赠送金(元)">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="lastLoginTime" label="最近一次登录时间" width="180">
							</el-table-column>
							<el-table-column label="操作" width="50">
								<template slot-scope="scope">
									<el-popover class="mypopover disCenter" placement="top-end" width="100"
										trigger="hover">
										<div class="pupBox">
											<span class="hoverClass" @click.stop="itemClick(scope.row,1)">详情</span>
											<span class="hoverClass" @click.stop="itemClick(scope.row,5)">功率配置</span>
											<span class="hoverClass" @click.stop="itemClick(scope.row,2)">充值记录</span>
											<span class="hoverClass" @click.stop="itemClick(scope.row,9)">提现记录</span>
											<span class="hoverClass" @click.stop="itemClick(scope.row,3)">充电记录</span>
											<span class="hoverClass" @click.stop="itemClick(scope.row,4)">赠送金记录</span>
											<span class="hoverClass" @click.stop="itemClick(scope.row,7)"
												v-if="scope.row.loginStatus==1">禁用</span>
											<span class="hoverClass" @click.stop="itemClick(scope.row,8)"
												v-if="scope.row.loginStatus==2">解除禁用</span>
										</div>
										<div slot="reference" class="itemRight listIcon"></div>
									</el-popover>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination  mypagination">
						<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
							:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
							layout="total, prev, pager, next,jumper" ref="pagination"
							@current-change="handleCurrentChange1">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="用户信息" center class="mydialog" :visible.sync="dialogVisible" width="60%">
			<div class="dialogBox3">
				<div class="contBox">
					<div class="itemBox  disStart">
						<div class="elBox ">
							<span class="nameBox">用户名:</span>
							<span class="valueBox">{{creatObj.loginId}}</span>
						</div>
						<div class="elBox">
							<span class="nameBox">姓名:</span>
							<span class="valueBox">{{creatObj.nickName}}</span>
						</div>
					</div>

					<div class="itemBox  disStart">
						<div class="elBox">
							<span class="nameBox">联系方式:</span>
							<span class="valueBox">{{creatObj.phone}}</span>
						</div>
						<div class="elBox">
							<span class="nameBox">剩余充值金(元):</span>
							<span class="valueBox">{{creatObj.accountBalance}}</span>
						</div>
					</div>
					<div class="itemBox  disStart">
						<div class="elBox ">
							<span class="nameBox">剩余赠送金(元):</span>
							<span class="valueBox">{{(creatObj.accountExtraBalance)}}</span>
						</div>
						<div class="elBox ">
							<span class="nameBox">已用充值金(元):</span>
							<span class="valueBox">{{(creatObj.accountBalanceUsed)}}</span>
						</div>
					</div>

					<div class="itemBox  disStart">
						<div class="elBox ">
							<span class="nameBox">已用赠送金(元):</span>
							<span class="valueBox">{{(creatObj.accountExtraBalanceUsed)}}</span>
						</div>
						<div class="elBox">
							<span class="nameBox">最近一次登录时间:</span>
							<span class="valueBox">{{creatObj.lastLoginTime}}</span>
						</div>
					</div>
					<div class="itemBox  disStart">
						<div class="elBox">
							<span class="nameBox">用户状态:</span>
							<span class="valueBox">{{getName(creatObj.loginStatus,statusList)}}</span>
						</div>
						<!-- <div class="elBox">
							<span class="nameBox">禁用时间:</span>
							<span class="valueBox">{{creatObj.accountBalance}}</span>
						</div> -->
					</div>
				</div>

			</div>

			<div slot="footer" class="diabtnBox">
				<el-button type="primary" @click="dialogVisible = false">确定</el-button>
			</div>
		</el-dialog>
		<!-- 充值记录 -->
		<el-dialog title="充值记录" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="dialogOperation1"
			width="80%">
			<div class="dialogBox dialogBox2">
				<div class="diaItem disBetween">
					<div class="myinputBox myinputBox5">
						<el-date-picker v-model="searchObj2.startTime" value-format="yyyy-MM-dd" type="date"
							placeholder="开始时间">
						</el-date-picker>
					</div>
					<div class="myinputBox myinputBox5">
						<el-date-picker v-model="searchObj2.endTime" value-format="yyyy-MM-dd" type="date"
							placeholder="结束时间">
						</el-date-picker>
					</div>
					<el-button type="success" @click="getoperationData">查询</el-button>
				</div>
				<div class="myTable myTable2" v-loading="loading2">
					<el-table :data="operationData" style="width: 100%">
						<el-table-column type="index" label="序号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="loginId" label="用户名">
							<template slot-scope="scope">
								<span>{{scope.row.loginId?((scope.row.loginId).slice(10)):""}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="rechargeAmount" label="充值金额(元)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="rechargeTime" label="充值时间">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="extraCoinAmount" label="赠送金额(元)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="accountBalance" label="账户剩余充值金额(元)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="accountExtraBalance" label="账户剩余赠送卷">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="rechargeType" label="充值类型">
							<template slot-scope="scope">
								<span>{{getName(scope.row.rechargeType,chargeTpyeList)}}</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination mypagination  mypagination2">
					<el-pagination background small :page-size="OperationInfo.pagesize"
						:current-page="OperationInfo.pagenum" :total="OperationInfo.total" :pager-count="5"
						prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange2($event,1)">
					</el-pagination>
				</div>
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button type="primary" @click="dialogOperation1 = false">确 定</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 充电记录 -->
		<el-dialog :title="mydialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogOperation2" width="90%">
			<div class="dialogBox dialogBox2">
				<div class="diaItem disBetween">
					<div class="myinputBox" v-if="payTypeList">
						<el-select v-model="searchObj2.payType" slot="prepend" placeholder="请选择充电方式">
							<el-option v-for="(item,inx) in payTypeList" :key="inx" :label="item.text"
								:value="item.value"></el-option>
						</el-select>
					</div>
					<div class="myinputBox myinputBox5">
						<el-date-picker v-model="searchObj2.startTime" value-format="yyyy-MM-dd" type="date"
							placeholder="开始时间">
						</el-date-picker>
					</div>
					<div class="myinputBox myinputBox5">
						<el-date-picker v-model="searchObj2.endTime" value-format="yyyy-MM-dd" type="date"
							placeholder="结束时间">
						</el-date-picker>
					</div>

					<el-button type="success" @click="getoperationData">查询</el-button>
				</div>
				<div class="myTable myTable2" v-loading="loading2">
					<el-table :data="operationData" style="width: 100%">
						<el-table-column type="index" label="序号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="cardNumber" label="卡号" v-if="active==1">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityName" label="所属社区">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communitySiteName" label="充电地址">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="设备编号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentPort" label="端口" width="55">
						</el-table-column>
						<el-table-column prop="startTime" label="充电时间" width="150">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="payType" label="支付方式" v-if="active!=1">
							<template slot-scope="scope">
								<span>{{scope.row.payType==1?"微信支付":scope.row.payType==2?"余额支付":""}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="orderStatus" label="充电情况">
							<template slot-scope="scope">
								<span>{{scope.row.orderStatus==1?"充电中":scope.row.orderStatus==2?"充电结束":scope.row.orderStatus==0?"未充电":""}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="communityEquipmentPortPower" label="最大功率(W)">
							<template slot-scope="scope">
								<span @click="showPower(scope.row)"
									class="clickUndline">{{scope.row.communityEquipmentPortPower}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="timeStr" label="实际时长"></el-table-column>
						<!-- <el-table-column show-overflow-tooltip prop="returnConsumeAmount"
							label="退款(元)"></el-table-column> -->
						<el-table-column show-overflow-tooltip prop="realConsumeAmount"
							label="实际营收(元)"></el-table-column>
						<!-- <el-table-column show-overflow-tooltip prop="orderId" label="订单号">
						</el-table-column> -->



						<!-- <el-table-column show-overflow-tooltip prop="equipmentServiceProvider" label="运营商">
						</el-table-column> -->



						<!-- <el-table-column show-overflow-tooltip prop="orderAmount" label="充电金额"></el-table-column> -->

						<!-- 	<el-table-column show-overflow-tooltip prop="refundReason" label="退款理由">
						</el-table-column> -->
						<el-table-column prop="operate" label="操作" width="60">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="itemClick(scope.row,6)">详情</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination mypagination  mypagination2">
					<el-pagination background small :page-size="OperationInfo.pagesize"
						:current-page="OperationInfo.pagenum" :total="OperationInfo.total" :pager-count="5"
						prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange2($event,2)">
					</el-pagination>
				</div>
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button type="primary" @click="dialogOperation2= false">确 定</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="充电功率(W)" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="visibleShow1"
			width="40%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm3" label-width="100px" class="demo-ruleForm">
				<div class=" dialogBox5">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="最小功率" prop="minNum">
								<div class="myinputBox">
									<el-input @input="numberChange(creatObj.minNum,2000,1)" v-model="creatObj.minNum"
										type="text" placeholder="请输入最低充电功率" oninput="value=value.replace(/[^\d]/g,'')">
										<template slot="append"></template></el-input>
									<!-- <el-select clearable v-model="creatObj.minNum" slot="prepend"
										placeholder="请选择最低输出功率">
										<el-option v-for="(item,inx) in minList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select> -->
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="最大功率" prop="maxPower">
								<div class="myinputBox">
									<el-input @input="numberChange(creatObj.maxPower,2000,2)"
										v-model="creatObj.maxPower" type="text" placeholder="请输入最低充电功率"
										oninput="value=value.replace(/[^\d]/g,'')">
										<template slot="append"></template></el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="visibleShow1=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm3')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="添加赠送金" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="visibleShow2"
			width="40%">
			<el-form :model="moneyObj" :rules="rules" ref="ruleForm4" label-width="100px" class="demo-ruleForm">
				<div class=" dialogBox5">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="赠送金" prop="accountExtraBalance">
								<div class="myinputBox">
									<el-input @input="numberChange(moneyObj.accountExtraBalance,20)"
										v-model="moneyObj.accountExtraBalance" type="text" placeholder="请输入赠送金"
										oninput="value=value.replace(/[^\d]/g,'')"></el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="备注" prop="remark">
								<div class="myinputBox">
									<el-input v-model="moneyObj.remark" placeholder="请输入备注"></el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="visibleShow2=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm4')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 赠送金记录 -->
		<el-dialog title="赠送金记录" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogOperation3" width="80%">
			<div class="dialogBox dialogBox2 dialogBox4">
				<div class="myTable myTable2" v-loading="loading2">
					<el-table :data="operationData" style="width: 100%">
						<el-table-column type="index" label="序号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="accountExtraBalance" label="赠送金额">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="loginId" label="用户名">
							<template slot-scope="scope">
								<span>{{scope.row.loginId?((scope.row.loginId).slice(10)):""}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="loginName" label="操作人">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="createTime" label="时间">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="remark" label="备注">
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination mypagination  mypagination2">
					<el-pagination background small :page-size="OperationInfo.pagesize"
						:current-page="OperationInfo.pagenum" :total="OperationInfo.total" :pager-count="5"
						prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange2($event,3)">
					</el-pagination>
				</div>
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button type="primary" @click="dialogOperation3= false">确 定</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 充电详情 -->
		<el-dialog title="充电记录" center class="mydialog" :visible.sync="dialogVisible1" width="60%">
			<div class="dialogBox ">
				<div class="contBox">
					<div class="itemBox itemBox1 disStart">
						<span>设备编号：{{creatObj.communityEquipmentNo}}</span>
						<span>订单号：{{creatObj.orderId}}</span>
						<span>用户名：{{creatObj.loginId}}</span>
					</div>
					<div class="itemBox itemBox1 disStart ">
						<span>端口：{{creatObj.communityEquipmentPort}}</span>
						<span>所属社区：{{creatObj.communityName}}</span>
						<span>充电地址：{{creatObj.communitySiteName}}</span>

					</div>
					<div class="itemBox itemBox1 disStart">
						<span>运营商：{{creatObj.equipmentServiceProvider}}</span>
						<span>充电时间：{{creatObj.startTime}}</span>
						<span>结束时间：{{creatObj.realEndTime}}</span>
					</div>
					<div class="itemBox itemBox1 disStart ">
						<span>充电时长(小时)：{{creatObj.rechargeTime}}</span>
						<span>充电最大功率(W)：{{creatObj.communityEquipmentPortPower}}</span>
						<span>实际时长：{{creatObj.timeStr}}</span>
					</div>
					<div class="itemBox itemBox1 disStart ">
						<span>充电金额(元)：{{creatObj.orderAmount}}</span>
						<span>退款(元)：{{creatObj.returnConsumeAmount}}</span>
						<span>实际营收(元)：{{creatObj.realConsumeAmount}}</span>

					</div>
					<div class="itemBox itemBox1 disStart ">
						<span>充电情况：
							<span
								:class="creatObj.orderStatus==1?'green':creatObj.orderStatus==2?'red':creatObj.orderStatus==0?'grey':''">{{creatObj.orderStatus==1?"充电中":creatObj.orderStatus==2?"充电结束":creatObj.orderStatus==0?"未充电":""}}</span>
						</span>
						<span>结束理由：{{creatObj.endReason}}</span>
						<span>退款理由：{{creatObj.refundReason}}</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer diabtnBox">
				<!-- <el-button @click="dialogVisible1 = false">取 消</el-button> -->
				<el-button type="primary" @click="dialogVisible1 = false">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog :title="title" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="showPowerEcharts" width="90%">
			<div class="changeBtnBox disStart">
				<span class="changeBtnItem disCenter" :class="{changeAct:typeActive==1}" @click="typeActive=1">功率</span>
				<span class="changeBtnItem disCenter" :class="{changeAct:typeActive==2}" @click="typeActive=2">电压</span>
				<span class="changeBtnItem disCenter" :class="{changeAct:typeActive==3}" @click="typeActive=3">电流</span>
			</div>
			<div class="statisticalRight" id="myEcharts2"></div>
		</el-dialog>
		<!-- 退款记录 -->
		<el-dialog title="提现记录" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="dialogOperation4"
			width="90%">
			<div class="dialogBox dialogBox2">
				<div class="diaItem disBetween">
					<div class="myinputBox myinputBox5">
						<el-date-picker v-model="searchObj2.startTime" value-format="yyyy-MM-dd" type="date"
							placeholder="开始时间">
						</el-date-picker>
					</div>
					<div class="myinputBox myinputBox5">
						<el-date-picker v-model="searchObj2.endTime" value-format="yyyy-MM-dd" type="date"
							placeholder="结束时间">
						</el-date-picker>
					</div>

					<el-button type="success" @click="getoperationData4">查询</el-button>
				</div>
				<div class="myTable myTable2" v-loading="loading2">
					<el-table :data="operationData" style="width: 100%">
						<el-table-column type="index" label="序号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="withdrawalTime" label="提现时间" width="140">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityName" label="社区">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="loginIdName" label="用户名">
						</el-table-column>
						<el-table-column prop="phone" label="联系方式" width="110">
						</el-table-column>
						<el-table-column prop="accountBalance" label="剩余充值金(元)" width="130">
						</el-table-column>
						<el-table-column prop="withdrawalAmount" label="提现金额(元)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="withdrawalCont" label="审核状态">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="approvalTime" label="审核时间" width="140">
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination mypagination  mypagination2">
					<el-pagination background small :page-size="OperationInfo.pagesize"
						:current-page="OperationInfo.pagenum" :total="OperationInfo.total" :pager-count="5"
						prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange2($event,4)">
					</el-pagination>
				</div>
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button type="primary" @click="dialogOperation4= false">确 定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import {
		number
	} from "echarts";
	import {
		timestampToDate
	} from "../../../assets/js/common.js"
	export default {
		name: "userManage",
		components: {},
		data() {
			var checkNum = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入赠送金'));
				}
				setTimeout(() => {
					console.log(1111)
					if (isNaN(parseFloat(value))) {
						callback(new Error('请输入数字值'));
					} else {
						callback();
					}
				}, 500);
			};
			return {
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				active: 0,
				title: "功率曲线图",
				showPowerEcharts: false,
				end: 80,
				min: 200,
				typeActive: 1,
				OperationInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				creatObj: {},
				dialogVisible: false,
				dialogOperation1: false,
				dialogOperation2: false,
				dialogOperation3: false,
				dialogOperation4: false,
				dialogVisible1: false,
				NOfalse: false,
				chargeTpyeList: [{
						text: "用户充值",
						value: 1
					},
					{
						text: "充电反币",
						value: 2
					},
					{
						text: "商城反币",
						value: 3
					}
				],
				tableData: [],
				operationData: [],
				statusList: [{
						text: "正常",
						value: 1
					},
					{
						text: "禁用",
						value: 2
					}
				],
				effectiveList: [{
						text: "无效用户",
						value: 1
					},
					{
						text: "有效用户",
						value: 2
					}
				],
				personList: [{
						text: "初级",
						value: 1
					},
					{
						text: "中级",
						value: 2
					},
					{
						text: "高级",
						value: 3
					}
				],
				visibleShow1: false,
				visibleShow2: false,
				minList: [{
						text: "10",
						value: 10
					},
					{
						text: "25",
						value: 25
					},
					{
						text: "40",
						value: 40
					},
					{
						text: "65",
						value: 65
					},
					{
						text: "80",
						value: 80
					},
					{
						text: "95",
						value: 95
					},
					{
						text: "110",
						value: 110
					},
					{
						text: "125",
						value: 125
					},
					{
						text: "140",
						value: 140
					},
					{
						text: "155",
						value: 155
					},
					{
						text: "170",
						value: 170
					},
					{
						text: "185",
						value: 185
					},
					{
						text: "200",
						value: 200
					}
				],
				loading: false,
				loading2: false,
				searchObj1: {
					communityId: "", //社区编号
					communitySiteId: "",
					communityEquipmentNo: "",
					equipmentStatus: "",
					equipmentRunStatus: "",
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
					searchData: [],
				},
				diaObj: {},
				searchObj2: {
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
					userName: "", //用户名称
					searchData: [],
					payType: 2,
					rechargeType: null, //充值类型 1用户充值 2充电反币 3商城反币
					startTime: "", //开始时间
					endTime: "" //结束时间
				},
				withdrawalFlagList: [{
						text: "审核中",
						value: 1
					}, {
						text: "审核通过",
						value: 2
					},
					{
						text: "审核不通过",
						value: 3
					}
				],
				payTypeList: [{
						text: "扫码充电",
						value: 2
					},
					{
						text: "电卡充电",
						value: 3
					}
				],
				restaurants: [],
				options: [],
				areaList: [],
				areaValue: "",
				moneyObj: {
					accountExtraBalance: "",
					remark: ""
				},
				mydialogTitle: "充电记录",
				rules: {
					accountExtraBalance: [{
							validator: checkNum,
							trigger: 'blur'
						},
						{
							required: true,
							message: '请输入赠送金',
							trigger: 'blur'
						}
					],
					minNum: [{
						required: true,
						message: '请输入最低充电功率',
						trigger: 'blur'
					}],
					maxPower: [{
						required: true,
						message: '请输入最大充电功率',
						trigger: 'blur'
					}],
					remark: [{
						required: true,
						message: '请输入备注',
						trigger: 'blur'
					}],
				},
				echartsObj: {}
			}
		},
		watch: {
			typeActive(n) {
				this.showEchart(n)
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getData()
				if (!(localStorage.getItem("areaList"))) {
					this.getAreaList()
				} else {
					this.$set(this, "areaList", JSON.parse(localStorage.getItem("areaList")))
				}
			})
		},
		methods: {
			showPower(obj) {
				this.title = "充电曲线图（" + obj.communityName + "-" + obj.communitySiteName + "-" + obj.communityEquipmentNo +
					"-插座" + obj.communityEquipmentPort + "）"
				this.$api.listPowerList({
					orderId: obj.orderId
				}).then((res) => {
					if (res.returnCode == 200) {
						if (res.obj && res.obj.length > 0) {
							this.showPowerEcharts = true
							if (res.obj.length > 10 && res.obj.length <= 20) {
								this.$set(this, "end", 80)
							} else if (res.obj.length > 20) {
								this.$set(this, "end", 120)
							} else {
								this.$set(this, "end", 40)
							}
							this.$set(this, "echartsObj", res.obj)

							this.$nextTick(() => {
								this.showEchart(1)
							})
						} else {
							this.$message('暂无充电功率记录');
						}

					}
				})

			},
			showEchart(n) {
				let item = {
					xDate: [],
					data: []
				}
				let arr = []
				let legen = ["充电功率"]
				let unit = "功率:W"
				if (n == 1) {
					unit = "功率:W"
					legen[0] = "充电功率"
				} else if (n == 2) {
					unit = "电压:V"
					legen[0] = "充电电压"
				} else if (n == 3) {
					unit = "电流:mA"
					legen[0] = "充电电流"
				}
				for (let k of this.echartsObj) {
					item.xDate.push(k.createTime)
					if (n == 1) {
						item.data.push(k.power)
						arr.push(k.power)
					} else if (n == 2) {
						item.data.push(k.voltage)
						arr.push(k.voltage)
					} else if (n == 3) {
						item.data.push(k.elecCurrent)
						arr.push(k.elecCurrent)
					}

				}
				arr.sort((a, b) => {
					return a - b
				})
				this.$set(this, "min", arr[0])
				let that = this
				let getchart = that.$echarts.init(document.getElementById('myEcharts2'));
				getchart.clear()
				var option = {
					tooltip: {
						trigger: "axis",
						// valueFormatter: function(value) {
						// 	console.log(value)
						// 	return value + "W"
						// }
					},
					grid: {
						top: "8%",
						left: "3%",
						right: "4%",
						bottom: "8%",
						containLabel: true,
					},
					lenged: {
						data: legen
					},
					xAxis: [{
						type: "category",
						axisLine: {
							lineStyle: {
								color: "#90979c",
							},
						},
						splitLine: {
							show: false,
						},

						splitArea: {
							show: false,
						},
						axisLabel: {
							// interval:0,
							formatter: function(params) {
								var newParamsName = "";
								var paramsNameNumber = params.length;
								var provideNumber = 10; //一行显示几个字
								var rowNumber = Math.ceil(
									paramsNameNumber / provideNumber
								);
								if (paramsNameNumber > provideNumber) {
									for (var p = 0; p < rowNumber; p++) {
										var tempStr = "";
										var start = p * provideNumber;
										var end = start + provideNumber;
										if (p === rowNumber - 1) {
											tempStr = params.substring(
												start,
												paramsNameNumber
											);
										} else {
											tempStr =
												params.substring(start, end) +
												"\n";
										}
										newParamsName += tempStr;
									}
								} else {
									newParamsName = params;
								}
								return newParamsName;
							}
						},
						data: item.xDate,
					}, ],
					yAxis: [{
						name: unit,
						type: "value",
						min: that.min,
						axisLine: {
							lineStyle: {
								color: "#90979c",
							},
						},

					}, ],
					dataZoom: [{
							show: true,
							height: 30,
							xAxisIndex: [0],
							bottom: -60,
							start: 0,
							end: that.end,
						},
						{
							type: "inside",
							show: true,
							height: 15,
							start: 1,
							end: 50,
						},
					],
					series: [{
						name: legen[0],
						type: "line",
						smooth: true, //是否平滑曲线显示
						symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
						symbolSize: 10,
						lineStyle: {
							normal: {
								color: "#03adac", // 线条颜色
							},
						},
						data: item.data,
					}, ],
				};

				getchart.setOption(option);
			},
			addMoney(item) {
				this.$set(this, "moneyObj", {
					accountExtraBalance: "",
					remark: "",
					loginId: item.loginId
				})
				this.visibleShow2 = true
				this.$refs.ruleForm4.clearValidate()
			},
			numberChange(val, maxNum, n) {
				if (n == 1) {
					//转换数字类型
					let num = Number(val)
					// if (num < 1) {
					// 	this.$set(this.creatObj, "minNum", 1)
					// }
					if (num > 2000) {
						this.$set(this.creatObj, "minNum", 2000)
					}
				} else if (n == 2) {
					//转换数字类型
					let num = Number(val)
					// if (num < 1) {
					// 	this.$set(this.creatObj, "maxPower", 1)
					// }
					if (num > 2000) {
						this.$set(this.creatObj, "maxPower", 2000)
					}
				} else {
					//转换数字类型
					let num = Number(val)
					if (num < 0) {
						this.$set(this.moneyObj, "accountExtraBalance", 0)
					}
					if (num > 100) {
						this.$set(this.moneyObj, "accountExtraBalance", 100)
					}
				}

			},
			exportData() {
				let obj = {}
				this.$api.exportUseInfo(obj, "用户列表").then((res) => {
					if (res.returnCode == 200) {

					}
				})
			},
			// 按钮保存 新增/编辑
			toSave(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (formName == "ruleForm4") {
							let obj = {
								loginId: that.moneyObj.loginId,
								accountExtraBalance: that.moneyObj.accountExtraBalance,
								remark: that.moneyObj.remark
							}
							that.$api.updateExtraAccount(obj).then((res) => {
								if (res.returnCode == 200) {
									that.$message({
										type: 'success',
										message: '操作成功!'
									});
									that.visibleShow2 = false
									that.$nextTick(() => {
										that.getData()
									})
								}
							})
						} else {
							if (Number(that.creatObj.minNum) <= 0) {
								that.$message({
									type: 'warning',
									message: '请输入最小充电功率!'
								});
								return false
							}
							if (Number(that.creatObj.maxPower) <= 0) {
								that.$message({
									type: 'warning',
									message: '请输入最大充电功率!'
								});
								return false
							}
							if (Number(that.creatObj.minNum) >= Number(that.creatObj.maxPower)) {
								that.$message({
									type: 'warning',
									message: '最小充电功率不能低于最大充电功率!'
								});
								return false
							}
							let obj = {
								minPower: JSON.parse(JSON.stringify(that.creatObj.minNum)) * 10,
								maxPower: JSON.parse(JSON.stringify(that.creatObj.maxPower)) * 10,
								loginId: that.creatObj.loginId
							}
							that.$api.updatePower(obj).then((res) => {
								if (res.returnCode == 200) {
									that.$message({
										type: 'success',
										message: '充电功率配置成功!'
									});
									that.visibleShow1 = false
									that.$nextTick(() => {
										that.getData()
									})
								}
							})
						}

					} else {
						return false;
					}
				});
			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				if(obj == undefined){
					return
				}else{
					return obj.text
				}
				console.log(obj);
				// return obj.text
			},
			// 1详情 2充值记录
			itemClick(item, n) {
				let that = this
				this.$set(this, "diaObj", item)

				if (n == 1) {
					this.dialogVisible = true
					this.$set(this, "creatObj", item)
				} else if (n == 2) {
					this.$set(this, "OperationInfo", {
						pagesize: 10,
						pagenum: 1,
						total: 0
					})
					this.$set(this.searchObj2, "pageNo", 1)
					this.$set(this.searchObj2, "startTime", "")
					this.$set(this.searchObj2, "endTime", "")
					this.$set(this.searchObj2, "loginId", item.loginId)
					this.listUserInfoAccountRecord(item)
				} else if (n == 3) {
					this.$set(this, "OperationInfo", {
						pagesize: 10,
						pagenum: 1,
						total: 0
					})
					this.$set(this.searchObj2, "pageNo", 1)
					this.$set(this.searchObj2, "startTime", "")
					this.$set(this.searchObj2, "endTime", "")
					this.$set(this.searchObj2, "loginId", item.loginId)
					this.listRechargeRecord()
				} else if (n == 4) {
					this.$set(this, "OperationInfo", {
						pagesize: 10,
						pagenum: 1,
						total: 0
					})
					this.$set(this.searchObj2, "pageNo", 1)
					this.$set(this.searchObj2, "startTime", "")
					this.$set(this.searchObj2, "endTime", "")
					this.$set(this.searchObj2, "loginId", item.loginId)
					this.listExtraAccount()
				} else if (n == 5) {
					this.visibleShow1 = true
					this.$set(this.creatObj, "minNum", JSON.parse(JSON.stringify(item.minPower)) / 10)
					this.$set(this.creatObj, "maxPower", JSON.parse(JSON.stringify(item.maxPower)) / 10)
					this.$set(this.creatObj, "loginId", item.loginId)
					this.$nextTick(() => {
						this.$refs.ruleForm3.clearValidate()
					})

				} else if (n == 6) {
					this.$set(this, "creatObj", item)
					this.$nextTick(() => {
						this.dialogVisible1 = true
					})
				} else if (n == 7) {
					this.$nextTick(() => {
						this.$confirm('是否禁用该用户?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							let obj = {
								loginId: item.loginId,
								loginStatus: 2,
								accountStatus: 2
							}
							that.updateUseStatus(obj)
						}).catch(() => {

						});
					})
				} else if (n == 8) {
					this.$nextTick(() => {
						this.$confirm('是否解除禁用该用户?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							let obj = {
								loginId: item.loginId,
								loginStatus: 1,
								accountStatus: 1
							}
							that.updateUseStatus(obj)
						}).catch(() => {

						});
					})
				} else if (n == 9) { //提现记录
					this.$set(this, "OperationInfo", {
						pagesize: 10,
						pagenum: 1,
						total: 0
					})
					this.$set(this.searchObj2, "pageNo", 1)
					this.$set(this.searchObj2, "startTime", "")
					this.$set(this.searchObj2, "endTime", "")
					this.$set(this.searchObj2, "loginId", item.loginId)
					this.listUserInfoAccountWithdrawalRecord()
				}
			},
			updateUseStatus(obj) {
				this.$api.updateUseStatus(obj).then((res) => {
					if (res.returnCode == 200) {
						this.getData()
					}
				})
			},
			listUserInfoAccountRecord(item) {
				let timeObj = {
					startTime: "",
					endTime: "",
				}
				if (this.searchObj2.searchData && this.searchObj2.searchData.length > 0) {
					timeObj.startTime = this.searchObj2.searchData[0]
					timeObj.endTime = this.searchObj2.searchData[1]
				} else {
					timeObj.startTime = ''
					timeObj.endTime = ''
				}
				this.loading2 = true
				let obj = {
					// loginId: this.searchObj2.loginId,
					pageNo: this.searchObj2.pageNo, //当前页
					pageSize: this.searchObj2.pageSize, //当前页个数
					userName: "", //用户名称
					loginId: this.diaObj.loginId,
					rechargeType: this.searchObj2.rechargeType, //充值类型 1用户充值 2充电反币 3商城反币
					startTime: timeObj.startTime, //开始时间
					endTime: timeObj.endTime //结束时间
				}
				this.$api.listUserInfoAccountRecord(obj).then((res) => {
					if (res.returnCode == 200) {
						this.loading2 = false
						this.$set(this, "operationData", res.obj.list || [])
						this.$set(this.OperationInfo, "total", res.obj.total || 0)
					}
				})
				this.dialogOperation1 = true
			},
			listRechargeRecord() {
				this.loading2 = true
				let timeObj = {
					startTime: "",
					endTime: "",
				}
				if (this.searchObj2.searchData && this.searchObj2.searchData.length > 0) {
					timeObj.startTime = this.searchObj2.searchData[0]
					timeObj.endTime = this.searchObj2.searchData[1]
				} else {
					timeObj.startTime = ''
					timeObj.endTime = ''
				}
				let obj = {
					// loginId: this.searchObj2.loginId,
					pageNo: this.searchObj2.pageNo, //当前页
					pageSize: this.searchObj2.pageSize, //当前页个数
					communityName: this.searchObj2.communityName || "",
					communitySiteId: this.searchObj2.communitySiteId || "",
					search: "", //用户名称
					loginId: this.diaObj.loginId,
					payType: this.searchObj2.payType,
					serviceProviderId: this.searchObj2.serviceProviderId || "", //充值类型 1用户充值 2充电反币 3商城反币
					startTime: timeObj.startTime, //开始时间
					endTime: timeObj.endTime //结束时间
				}
				this.$api.listRechargeRecord(obj).then((res) => {
					if (res.returnCode == 200) {
						this.loading2 = false
						for (let k of res.obj.list || []) {
							k.timeStr = this.gettime(k.realRechargeTime)
						}
						this.$set(this, "operationData", res.obj.list || [])
						this.$set(this.OperationInfo, "total", res.obj.total || 0)
					}
				})
				if (this.searchObj2.payType == 3) {
					this.mydialogTitle = "卡充电记录(卡号：" + (obj.cardNumber || '-') + ")"
				} else {
					this.mydialogTitle = "充电记录"
				}
				this.dialogOperation2 = true
			},
			listExtraAccount() {
				this.loading2 = true
				let obj = {
					pageNo: this.searchObj2.pageNo, //当前页
					pageSize: this.searchObj2.pageSize, //当前页个数
					loginId: this.diaObj.loginId,
				}
				this.$api.listExtraAccount(obj).then((res) => {
					if (res.returnCode == 200) {
						this.loading2 = false
						this.$set(this, "operationData", res.obj.list || [])
						this.$set(this.OperationInfo, "total", res.obj.total || 0)
					}
				})
				this.dialogOperation3 = true
			},
			listUserInfoAccountWithdrawalRecord() {
				this.loading2 = true
				let obj = {
					pageNo: this.searchObj2.pageNo, //当前页
					pageSize: this.searchObj2.pageSize, //当前页个数
					loginId: this.diaObj.loginId,
				}
				this.$api.listUserInfoAccountWithdrawalRecord(obj).then((res) => {
					if (res.returnCode == 200) {
						this.loading2 = false
						for (let k of res.obj.list) {
							k.withdrawalName = this.getName(k.withdrawalFlag, this.withdrawalFlagList)
							k.loginIdName = (k.loginId).slice(10)
							k.withdrawalCont = this.getName(k.withdrawalFlag, this.withdrawalFlagList) + (k
								.withdrawalFlag == 3 ? '(' + k.auditReason + ')' : "")
						}
						this.$set(this, "operationData", res.obj.list || [])
						this.$set(this.OperationInfo, "total", res.obj.total || 0)
					}
				})
				this.dialogOperation4 = true
			},
			gettime(n) {
				let result = "";
				if (n >= 12) {
					result = 12
				} else {
					let value = parseInt(n * 3600) //总数
					var secondTime = parseInt(value); // 秒
					var minuteTime = 0; // 分
					var hourTime = 0; // 小时
					if (secondTime > 60) {
						minuteTime = parseInt(secondTime / 60);
						secondTime = parseInt(secondTime % 60);
						if (minuteTime > 60) {
							hourTime = parseInt(minuteTime / 60);
							minuteTime = parseInt(minuteTime % 60);
						}
					}

					if (secondTime > 0) {
						result = "" + parseInt(secondTime) + "秒";
					}

					if (minuteTime > 0) {
						result = "" + parseInt(minuteTime) + "分" + result;
					}
					if (hourTime > 0) {
						result = "" + parseInt(hourTime) + "小时" + result;
					}
				}
				return result;
			},
			// 省市区数据
			getAreaList() {
				this.$api.listAllAreaInfo().then((res) => {

					if (res.returnCode == 200) {
						this.$set(this, "areaList", res.obj)
						localStorage.setItem('areaList', JSON.stringify(res.obj))
					}
				})
			},
			remoteMethod(query) {
				let that = this
				if (query !== '') {
					let searchObj1 = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 1000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj1).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);

						}
					})

				} else {
					this.options = [];
				}
			},
			toSearch() {
				this.$set(this.PageInfo, "pagenum", 1)
				this.$set(this.searchObj1, "pageNo", 1)
				this.$nextTick(() => {
					this.getData()
				})
			},
			getoperationData() {
				this.$set(this.OperationInfo, "pagenum", 1)
				this.$set(this.searchObj2, "pageNo", 1)
				this.$nextTick(() => {
					if (this.dialogOperation1) {
						this.listUserInfoAccountRecord()
					} else {
						if (this.searchObj2.payType == 2) {
							this.active = 0
						} else {
							this.active = 1
						}
						this.listRechargeRecord()
					}
				})
			},
			getoperationData4() {
				this.$set(this.OperationInfo, "pagenum", 1)
				this.$set(this.searchObj2, "pageNo", 1)
				this.$nextTick(() => {
					this.listUserInfoAccountWithdrawalRecord()
				})
			},
			getData(n) {
				this.loading = true
				this.$api.listUseInfo(this.searchObj1).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						this.$set(this, "tableData", res.obj.list || [])
						this.$set(this.PageInfo, "total", res.obj.total || 0)
						this.loading = false
					}
				})
			},
			// 选择分页
			handleCurrentChange1(val) {
				this.$set(this.PageInfo, "pagenum", val)
				this.$set(this.searchObj1, "pageNo", val)
				this.getData({})
			},
			handleCurrentChange2(val, n) {
				this.$set(this.OperationInfo, "pagenum", val)
				this.$set(this.searchObj2, "pageNo", val)
				this.$nextTick(() => {
					if (n == 1) {
						this.listUserInfoAccountRecord()
					} else if (n == 2) {
						this.listRechargeRecord()
					} else if (n == 3) {
						this.listExtraAccount()
					} else if (n == 4) {
						this.listUserInfoAccountWithdrawalRecord()
					}
				})
			},
			handleChange(value, n) {
				let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()
				if (nodesInfo.length > 0) {
					this.$set(this.searchObj1, "provinceCode", nodesInfo[0].path[0] || "")
					this.$set(this.searchObj1, "cityCode", nodesInfo[0].path[1] || "")
					this.$set(this.searchObj1, "areaCode", nodesInfo[0].path[2] || "")
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./userManage.scss";
</style>